import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { appSetRoute,
         deliveriesConnect, 
         deliveriesDisconnect,
         delivStart,
         delivStartUpd,
         ordersUpdate,
         sensorsConnect,
         sensorsDisconnect } from '../../store/actions';

import Deliv from '../../components/Deliv';

class Cdeliv extends Component {
    constructor(props){
        super(props);

        this.delivClick = this.delivClick.bind(this);
        this.delivStartClick = this.delivStartClick.bind(this);
        this.delivStartUpd = this.delivStartUpd.bind(this);
    }

    componentDidMount() {
        this.props.deliveriesConnect();
        this.props.sensorsConnect();
    }

    render() {
        return (
            <div>
                { this.props.deliveries.length>0 &&
                <Deliv
                    deliveries={this.props.deliveries}
                    sensors={this.props.sensors}
                    sensorsUpdate={this.props.sensorsUpdate}

                    texts={{
                        boar: this.props.txt_boar,
                        cia: this.props.txt_cia,
                        deliv: this.props.txt_deliv,
                        deliveries: this.props.txt_deliveries,
                        inideliv: this.props.txt_inideliv,
                        inideliv2: this.props.txt_inideliv2,
                        nodeliv: this.props.txt_nodeliv,
                        orders: this.props.txt_orders,
                        ordersDeliv: this.props.txt_ordersDeliv,
                        plate: this.props.txt_plate,
                        sensor: this.props.txt_sensor,
                        truck: this.props.txt_truck
                    }}

                    onClick={this.delivClick}
                    onDelivStartClick={this.delivStartClick}
                    onDelivStartUpd={this.delivStartUpd}
                />}
            </div>
        );
    }

    delivClick(key) {
        const deliv = this.props.deliveries.filter(i=>{return i._key===key})[0];

        if (!deliv.delivery_start_date) return;
        
        this.props.ordersUpdate({
            delivery: deliv,
            orders: deliv.orders
        });
        
        this.props.appSetRoute('orders');
    }

    delivStartClick(key) {
        this.props.delivStart(key);        
    }

    delivStartUpd(data) {        
        this.props.delivStartUpd(data);        
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];
        } catch (err) {
            text = '';
        }
        return text;
    }
    
    return {
        delivState: state.deliveries.delivState,
        deliveries: state.deliveries.deliveries,
        loginState: state.login.loginState,
        plate: state.app.plate,
        sensors : state.sensors.sensors,
        sensorsUpdate: state.sensors.sensorsUpdate,

        txt_boar: getText("0018"),
        txt_cia: getText("0045"),
        txt_deliv: getText("0029"),
        txt_inideliv: getText("0049"),
        txt_inideliv2: getText("0050"),
        txt_deliveries: getText("0006"),
        txt_nodeliv: getText("0016"),
        txt_orders: getText("0042"),
        txt_ordersDeliv: getText("0048"),
        txt_plate: getText("0021"),
        txt_sensor: getText("0044"),
        txt_truck: getText("0020")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appSetRoute: (route) => dispatch(appSetRoute(route)),
        deliveriesConnect: () => dispatch(deliveriesConnect()),
        deliveriesDisconnect: () => dispatch(deliveriesDisconnect()),
        delivStart: (key) => dispatch(delivStart(key)),
        delivStartUpd: (data) => dispatch(delivStartUpd(data)),
        ordersUpdate: (data) => dispatch(ordersUpdate(data)),
        sensorsConnect: () => dispatch(sensorsConnect()),
        sensorsDisconnect: () => dispatch(sensorsDisconnect())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Cdeliv));



// WEBPACK FOOTER //
// ./src/containers/Cdeliv/index.js